export * from "./TabTemplate";
export { default as TabTemplate } from "./TabTemplate";
